import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from "react-intl";
import { Typography } from '@material-ui/core';

import { getI18n } from "../../../utils/intl";
import { getThemes } from '../../../reducers/portalConfig';
import { getVersionData } from '../../../reducers/login';
import { fetchVersion } from "../../../actions/login";

import { LABELS } from '../constants';
import { getThemeDetails } from "../utils";

const Version = () => {
  const intl = getI18n(useIntl());
  const globalDispatch = useDispatch();
  
  const themeData = useSelector(getThemes);
  const { shouldDisplayVersion } = getThemeDetails(themeData);
  
  const { data: versionNumber, isLoading: isVersionLoading, error: versionError }
    = useSelector(getVersionData);
  
  React.useEffect(() => {
    globalDispatch(fetchVersion());
  }, []);
  
  if (versionError) {
    console.error("Error while fetching version number: ", versionError);
  }
  
  if (isVersionLoading) return null;
  return shouldDisplayVersion
    ? (
      <Typography data-apim-test={'login-version'} align="center">
        {intl.getI18nMessage(LABELS.version)} {versionNumber}
      </Typography>
    ) : null
}

export default Version;